import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, DollarSign, User, Users, Zap, FileText, IdCard, Scale, Grid2X2 } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import _, { isEmpty } from "lodash";
import axios from "axios";

import { useMedia } from "../../hooks/useMedia";
import { useSnackbar } from "../../hooks/useSnackbar";

import {cnpjAlphanumeric as cnpjMask} from "../../constants/validate"
import { floatToCurrency, formatDate } from "../../constants/validate";

import DebtInformation from "../../components/DebtInformation";
import ChargeHome from "./components/ChargeHome";
import DataConfirmation from "./components/DataConfirmation";
import PaymentConfirmation from "./components/PaymentConfirmation";
import SelectInstallments from "./components/SelectInstallments";
import SuccessMessage from "./components/SuccessMessage";
import ReasonToReject from "./components/ReasonToReject";
import FinalizedProposal from "./components/FinalizedProposal";
import AgreementConfirmation from "./components/AgreementConfirmation";
import moment from "moment";
import "./index.scss";
import RenderModal from "./components/CnpjModal";
import Chat from "../../components/Chat";

function Charge() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { caseId } = useParams();
  const snackbar = useSnackbar();
  const [step, setStep] = useState(0);
  const [currentStatusCase, setCurrentStatusCase] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [listIsLoading, setListIsLoading] = useState(true);
  const { debtInfo } = useSelector((state) => state.charge);
  const { currentCase } = useSelector((state) => state.crm);
  const { user } = useSelector((state) => state.app);
  

  const [showDebtInfo, setShowDebtInfo] = useState(false);
  const isMobile = useMedia("(max-width: 960px)");

  const accordions = [];
  const [partnerCnpj, setPartnersCnpj] = useState([]);

  function manyDays(date) {
    let days = moment(date).diff(new Date(), 'days')
    // days += 1;
    return "Faltam " + days + (days > 1 ? " dias" : "dia");
  }

  const rejectPropoposalAccordion = {
    key: "REJECTED_PROPOSAL",
    title: "Proposta rejeitada",
    component: <FinalizedProposal direction="column" />,
  };

  const completedPropoposalAccordion = {
    key: "WAITING_APPROVAL_PROPOSAL",
    title: "Proposta aceita",
    component: <FinalizedProposal direction="column" />,
  };

  if (isMobile && debtInfo?.status === "ARCHIVED") {
    accordions.push(rejectPropoposalAccordion);
  }

  if (isMobile && debtInfo?.status === "PAID") {
    accordions.push(completedPropoposalAccordion);
  }

  let topics = [];

  if (debtInfo) {


    if(currentCase?.cases_types_id === 1){

    topics = [

      {
        Icon: User,
        title: "Nome do estabelecimento",
        value: debtInfo?.company?.name,
        hasSubtopics: false,
      },
      {
        Icon: Clock,
        title: "Débito aberto em",
        value: formatDate(debtInfo?.openingDate, false),
        hasSubtopics: false,
      },
      {
        Icon: DollarSign,
        title: "Valor histórico",
        value: floatToCurrency(Number(debtInfo?.totalDebt)),
        hasSubtopics: false,
      },
      // {
      //   Icon: Zap,
      //   title: "Valor atualizado",
      //   value: debtInfo.refreshedValue
      //     ? floatToCurrency(Number(debtInfo.refreshedValue))
      //     : "--",
      //   hasSubtopics: false,
      // },
      {
        Icon: Users,
        title: "Sócios",
        value: allPartners(debtInfo?.partners),
        hasSubtopics: false,
      },
      {
        Icon: FileText,
        title: "Minuta",
        value:
          debtInfo?.status === "WAITING_PAYMENT" ||
            debtInfo?.status === "WAITING_APPROVAL" ||
            debtInfo?.status === "WAITING"
            ? debtInfo?.missingSignatures === 0
              ? "Assinada com sucesso"
              : debtInfo?.missingSignatures === 1
                ? "Falta 1 assinatura"
                : `Faltam ${debtInfo?.missingSignatures} assinaturas`
            : "-",
        hasSubtopics: false,
      },
    ];

    if (debtInfo?.status === 'NEGOTIATION') {
      topics.push({
        Icon: User,
        title: "Vencimento da proposta",
        value: moment(currentCase.calculation_date).add(-1, "days").format("DD/MM/YYYY"),
        hasSubtopics: true,
        subtopics: [{
          description: moment(currentCase.calculation_date).add(-1, "days").format("DD/MM/YYYY")
        }, {
          description: manyDays(currentCase.calculation_date)
        }]
      });

    }
  }else{

    topics = [

      {
        Icon: User,
        title: "Nome do estabelecimento",
        value: debtInfo?.company?.name,
        hasSubtopics: false,
      },
      {
        Icon: IdCard,
        title: "CNPJ",
        value: cnpjMask(debtInfo?.cnpj),
        hasSubtopics: false,
      },
      // {
      //   Icon: Zap,
      //   title: "Valor atualizado",
      //   value: debtInfo.refreshedValue
      //     ? floatToCurrency(Number(debtInfo.refreshedValue))
      //     : "--",
      //   hasSubtopics: false,
      // },
      {
        Icon: Users,
        title: "Sócios",
        value: allPartners(debtInfo?.partners.filter(partner => partner.relationship_name === 'SOCIO-ADMINISTRADOR')),
        hasSubtopics: false,
      },{
        Icon: Scale,
        title: "Advogados",
        value: allPartners(debtInfo?.partners.filter(partner => partner.relationship_name === 'ADVOGADO')),
        hasSubtopics: false,
      },{
        Icon: Grid2X2,
        title: "Número do processo",
        value: currentCase?.process_number,
        hasSubtopics: false,
      },
      // {
      //   Icon: FileText,
      //   title: "Minuta",
      //   value:
      //     debtInfo?.status === "WAITING_PAYMENT" ||
      //       debtInfo?.status === "WAITING_APPROVAL" ||
      //       debtInfo?.status === "WAITING"
      //       ? debtInfo?.missingSignatures === 0
      //         ? "Assinada com sucesso"
      //         : debtInfo?.missingSignatures === 1
      //           ? "Falta 1 assinatura"
      //           : `Faltam ${debtInfo?.missingSignatures} assinaturas`
      //       : "-",
      //   hasSubtopics: false,
      // },
    ];

    if (debtInfo?.status === 'NEGOTIATION') {
      topics.push({
        Icon: User,
        title: "Vencimento da proposta",
        value: moment(currentCase.calculation_date).add(-1, "days").format("DD/MM/YYYY"),
        hasSubtopics: true,
        subtopics: [{
          description: moment(currentCase.calculation_date).add(-1, "days").format("DD/MM/YYYY")
        }, {
          description: manyDays(currentCase.calculation_date)
        }]
      });
    }
    }

  }

  useEffect(() => {
    if (user) {
      snackbar("Aguarde, estamos gerando sua proposta", {
        time: -1,
      });

      axios
        .get("case/get-user-case")
        .then((response) => {
          setPartnersCnpj(response.data.caseId)
        })
        .catch((e) => {
          console.error("Error on get user case.", e);

          snackbar("", {
            time: -1,
            closeSnackbar: true,
          });
          setIsLoading(false);
        });
    }
  }, [user]);

  useEffect(() => {
    if (caseId && !_.isEmpty(user)) {
      fetchCase(true);
      fetchList();
    }
  }, [caseId, user]);

  useEffect(() => {
    const timer = 10 * 1000;
    const interval = setInterval(async () => {
      if (!_.isEmpty(user) && !isLoading) {
        await fetchCase(false);
      }
      if (!_.isEmpty(user) && !listIsLoading) {
        await fetchList();
      }
    }, timer);

    return () => clearInterval(interval);
  }, [user, isLoading, listIsLoading]);

  // useEffect(() => {
  //   if(step === 1 && currentCase?.cases_types_id && currentCase?.cases_types_id !== 2) setStep(2)
  // },[ currentCase])

  useEffect(() => {
    if(debtInfo?.statusDescription) setCurrentStatusCase(debtInfo?.statusDescription)
  },[debtInfo])

  function handleChangeStep(value) {
    setStep(value);
  }

  function handleToggleDebtInfo() {
    setShowDebtInfo((prevState) => !prevState);
  }

  function allPartners(partners) {
    let result = "";
    partners.forEach((item) => {
      result = result + item.name + ", ";
    });
    return result.slice(0, -2);
  }

  // function returnDebts(debts) {
  //   let result = [{ description: "Referência", value: "Valor", type: "text" }];

  //   debts.forEach((item) => {
  //     result.push({
  //       description: item.reference,
  //       value: item.value,
  //       type: "currency",
  //     });
  //   });
  //   return result;
  // }

  async function fetchList() {
    function returnStatusText(statusId) {
      switch (statusId) {
        case 1:
          return "SENT";
        case 2:
          return "NEGOTIATION";
        case 3:
          return "WAITING_APPROVAL";
        case 4:
          return "PAID";
        case 5:
          return "ARCHIVED";
        case 7:
          return "WAITING";
        case 9:
          return "CLOSED";
        default:
          return "WAITING_PAYMENT";
      }
    }

    function returnStatusDescription(statusId) {
      switch (statusId) {
        case 1:
          return "Aguardando contato";
        case 2:
          return "Negociando";
        case 3:
          return "Aguardando assinaturas";
        case 4:
          return "Concluido";
        case 5:
          return "Arquivado";
        case 6:
          return "Aguardando pagamento";
        case 7:
          return "Aguardando assinatura e pagamento";
        case 9:
          return "Encerrado";
        case 10: 
          return "Negociando"
        case 11: 
          return "Aguardando contato"
        case 12: 
          return "Aguardando assinaturas"
        case 13: 
          return "Concluido"
        case 14: 
          return "Aguardando pagamento"
        case 15: 
          return "Aguardando assinatura e pagamento"
        case 16: 
          return "Encerrado"
        case 17: 
          return "Arquivado"
        default:
          return "Negociando por chat";
      }
    }

    console.log("case id ... ", caseId)
    await axios
      .post(`/case/list/${caseId}`, {})
      .then(({ data }) => {

        let dataIndex = null;

        data.map((item) => {
          if (item.id === caseId) {
            dataIndex = data.indexOf(item);
          }


          if (dataIndex !== null) {
            const debt = data[dataIndex];
            const payload = {
              id: debt.id,
              openingDate: debt.opening_date,
              company: {
                name: debt.company,
                cnpj: debt.cnpj,
              },
              status: returnStatusText(debt.status_cases_id),
              statusDescription: returnStatusDescription(debt.status_cases_id),
              totalDebt: debt.value,
              signatureUrl: debt.signature_url,
              partners: debt.partners,
              debts: debt.debts,
              cnpj: debt.cnpj,
              missingSignatures: debt.missingSignatures,
              documentUrl: debt.document_url,
              minute_signed: debt.signed
            };

            dispatch({ type: "CHANGE_DEBT_INFO", payload });
            if (
              debt.status_cases_id === 3 ||
              debt.status_cases_id === 6 ||
              debt.status_cases_id === 7
            ) {
              setStep(7);
            }
          }
        });

      })
      .catch((error) => {
        console.error("Axios error, get case list.", error);
      })
      .finally(() => {
        setListIsLoading(false);
      });
  }

  function fetchCase(first = false) {
    axios
      .get(`case/open-mail/${caseId}`)
      .then(({ data }) => {
        let activeProposals = data.activeProposals;
        let archivedProposals = data.oldProposals;
        let acceptedProposal = data.acceptedProposal;
        let unpaidProposals = data.unpaidProposals;
        let cases = data?.case

        if (archivedProposals?.length > 0) {
          archivedProposals = archivedProposals.map(
            (archivedProposal) => archivedProposal
          );
        }

        if (cases.length > 0)
          dispatch({ type: "CHANGE_CURRENT_CASE", payload: cases[0] });

        dispatch({ type: "CHANGE_ACTIVE_PROPOSALS", payload: activeProposals });
        dispatch({
          type: "CHANGE_ARCHIVED_PROPOSALS",
          payload: archivedProposals,
        });

        dispatch({
          type: "CHANGE_UNPAID_PROPOSALS",
          payload: unpaidProposals,
        });

        if (first) {
          dispatch({
            type: "CHANGE_DEBT_INFO",
            payload: {
              refreshedValue: data.refreshedValue,
              status: "NEGOTIATION",
            },
          });
        } else {

          dispatch({
            type: "CHANGE_DEBT_INFO",
            payload: {
              refreshedValue: data.refreshedValue,
            },
          });
        }
        if (acceptedProposal) {
          const { number_installments, value, interest_rate, id } =
            acceptedProposal;
          let payment = {
            paymentType: number_installments > 1 ? "credit" : "cash",
            total: value * number_installments,
            interestRate: interest_rate,
            numberInstallments: number_installments,
            valueInstallments: value,
            proposalId: id,
          };
          dispatch({ type: "CHANGE_PAYMENT", payload: payment });
        }
        snackbar("", {
          time: -1,
          closeSnackbar: true,
        });
      })
      .catch((error) => {
        console.error(error);
        snackbar("", {
          time: -1,
          closeSnackbar: true,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function checkShowDebtInfo() {
    if (caseId == undefined) return false;
    if (step === 5) return false;

    if (step === 8 && isMobile && !showDebtInfo) return false;

    return true;
  }

  function returnClassName() {
    let className = "charge";

    if (step === 1) className += " charge--home";
    if (step === 8) className += " charge--full-screen";

    return className;
  }

  function selectCnpj(caseId) {
    navigate(`/caso/${caseId}`)
  }

  return (
    <div className={returnClassName()}>
      
      {checkShowDebtInfo() && (
        <div className="charge__wrapper-info">
          <DebtInformation
            title="Informações"
            topics={topics}
            hasStatus
            statusProposal={debtInfo?.status}
            classSpecial={
              step !== 1 && step !== 8 ? "debt-info--only-desktop" : ""
            }
            isLoading={listIsLoading}
            hasCloseIcon={!listIsLoading && step === 8}
            handleClose={handleToggleDebtInfo}
          />
        </div>
      )}
      
      {
        step === 0 && partnerCnpj.length >= 2 &&
        (
          <RenderModal
            caseObj={partnerCnpj}
            show={true}
            onConfirmation={selectCnpj}
            handleChangeStep={handleChangeStep}
          />
        )
      }

      {
        step === 0 && partnerCnpj.length === 1 &&
        (
          <RenderModal
            caseObj={partnerCnpj}
            show={false}
            onConfirmation={selectCnpj}
            handleChangeStep={handleChangeStep}
          />
        )
      }
      {(step === 1 && currentCase?.cases_types_id === 1) && (
        <ChargeHome
          handleChangeStep={handleChangeStep}
          isLoadingProposals={isLoading}
          isLoadingList={listIsLoading}
        />
      )}

      {(step === 1 && currentCase?.cases_types_id === 2) && (
        <div className="charge__chat-container">
          <header className="charge__chat-container__header">
            <h1 className="charge__chat-container__header__title">Chat</h1>
            {/* <div className="charge__chat-container__header__tag">{currentStatusCase}</div> */}
          </header>
          <Chat currentStatusCase={currentStatusCase} handleChangeStatus={name => setCurrentStatusCase(name)} caseId={caseId}/>
        </div>
      )}
      {step === 2 && <SelectInstallments handleChangeStep={handleChangeStep} />}
      {step === 3 && (
        <PaymentConfirmation handleChangeStep={handleChangeStep} />
      )}
      {step === 4 && <DataConfirmation handleChangeStep={handleChangeStep} />}
      {step === 5 && <SuccessMessage handleChangeStep={handleChangeStep} />}
      {step === 6 && <ReasonToReject handleChangeStep={handleChangeStep} />}
      {step === 7 && (
        <AgreementConfirmation handleChangeStep={handleChangeStep} />
      )}
      {/* {step === 7 && <DraftSignature handleChangeStep={handleChangeStep} />} */}
    </div>
  );
}

export default Charge;
